<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  page: { type: Number, required: true },
  totalPages: { type: Number, required: true },
  visibleCount: { type: Number, default: 0 },
  totalCount: { type: Number, default: 0 },
});

const emit = defineEmits(['change']);
const { t } = useI18n();
const pages = computed(() => {
  const total = Math.max(props.totalPages, 1);
  const start = Math.max(1, Math.min(props.page - 2, total - 4));
  return Array.from(
    { length: Math.min(total, 5) },
    (_, index) => start + index
  );
});
</script>

<template>
  <div class="flex flex-wrap items-center justify-between gap-3">
    <p class="text-sm text-lais-text-muted">
      {{
        t('REAL_ESTATE_BROKER_DASHBOARD.FILTERS.SHOWING', {
          visible: visibleCount,
          total: totalCount,
        })
      }}
    </p>
    <div v-if="totalPages > 1" class="flex items-center gap-1">
      <LaisPrimaryButton
        size="sm"
        variant="ghost"
        :disabled="page <= 1"
        @click="emit('change', page - 1)"
      >
        {{ t('REAL_ESTATE_BROKER_DASHBOARD.PAGINATION.PREVIOUS') }}
      </LaisPrimaryButton>
      <button
        v-for="item in pages"
        :key="item"
        type="button"
        class="grid size-8 place-items-center rounded-full text-sm font-semibold"
        :class="
          item === page
            ? 'bg-lais-primary text-white'
            : 'text-lais-text-body hover:bg-lais-primary-50'
        "
        :aria-current="item === page ? 'page' : undefined"
        @click="emit('change', item)"
      >
        {{ item }}
      </button>
      <LaisPrimaryButton
        size="sm"
        variant="ghost"
        :disabled="page >= totalPages"
        @click="emit('change', page + 1)"
      >
        {{ t('REAL_ESTATE_BROKER_DASHBOARD.PAGINATION.NEXT') }}
      </LaisPrimaryButton>
    </div>
  </div>
</template>
